(function () {
  if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) return;
  if (navigator.connection && (navigator.connection.saveData || /(^|-)2g$/.test(navigator.connection.effectiveType))) return;
  var link = document.createElement('link');
  if (!link.relList || !link.relList.supports('prefetch')) return;
  link.rel = 'prefetch';
  var seen = new Set();
  var timer;
  function candidate(event) {
    var a = event.target.closest && event.target.closest('a[href]');
    if (!a || a.closest('[data-no-instant]') || a.hasAttribute('download') || a.target === '_blank' || a.rel.split(/\s+/).includes('nofollow')) return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin || url.search || /^\/(cart|checkout|checkouts|account|search|apps|password|challenge|tools)(\/|$)/.test(url.pathname) || url.pathname === location.pathname || seen.has(url.href)) return;
    return url.href;
  }
  function preload(url) {
    if (!url || seen.has(url)) return;
    seen.add(url);
    var hint = link.cloneNode();
    hint.href = url;
    document.head.appendChild(hint);
  }
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    clearTimeout(timer);
    var url = candidate(event);
    if (url) timer = setTimeout(function () { preload(url); }, 100);
  }, { passive: true });
  document.addEventListener('pointerout', function () { clearTimeout(timer); }, { passive: true });
  document.addEventListener('touchstart', function (event) { preload(candidate(event)); }, { passive: true });
})();
